/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { RegistryOfficeByRegistryResponse } from '../../models/registry-office-by-registry-response';

export interface OfficeControllerGetAllByRegistry$Params {
  limit: number;
  skip: number;
}

export function officeControllerGetAllByRegistry(http: HttpClient, rootUrl: string, params: OfficeControllerGetAllByRegistry$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeByRegistryResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerGetAllByRegistry.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryOfficeByRegistryResponse;
      }>;
    })
  );
}

officeControllerGetAllByRegistry.PATH = '/registry/office/list-by-registry/warehouses';
